export { PrimaryRecommendationProgramDetailScreen } from './PrimaryRecommendationProgramDetailScreen';
